var _rect, _rect2, _rect3, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 72 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#024FA2",
    width: 72,
    height: 36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    y: 6,
    width: 72,
    height: 24
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ED1C27",
    y: 7,
    width: 72,
    height: 22
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 24,
    cy: 18,
    r: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(24,18) scale(7.75)",
    fill: "#ED1C27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cone"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "triangle",
    points: "0,0 0,1 .5,1",
    transform: "translate(0,-1) rotate(18)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#triangle",
    transform: "scale(-1,1)",
    id: "use12"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(72)",
    id: "use14"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(-72)",
    id: "use16"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(144)",
    id: "use18"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cone",
    transform: "rotate(-144)",
    id: "use20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKp);
export default __webpack_public_path__ + "static/media/kp.24c2b8095d90a7763af2ea5756126df0.svg";
export { ForwardRef as ReactComponent };